<template>
  <div class="p-2">
    <div class="d-flex align-items-center justify-content-between mb-2">
      <h4 class="mb-0">Talentos</h4>
      <b-button
        variant="primary"
        @click="$router.push({ name: 'talentos_nueva_propuesta' })"
      >
        <feather-icon icon="PlusIcon" size="16" class="mr-50" />
        Agregar propuesta
      </b-button>
    </div>
    <div v-if="loading" class="text-center py-4">
      <b-spinner variant="primary" />
    </div>
    <div v-else-if="proposals.length === 0" class="text-center text-muted py-4">
      Sin propuestas
    </div>
    <div v-else class="grid-talentos">
      <talentos-card
        v-for="proposal in proposals"
        :key="proposal.uuid"
        :proposal="proposal"
        :countries="countries"
        @unlinked="onUnlinked"
      />
    </div>
  </div>
</template>

<script>
import { BSpinner, BButton } from 'bootstrap-vue'
import proposal_service from '@/services/proposals'
import { getUserData } from '@/libs/utils/user'
import { getCountries } from '@/libs/utils/others'

export default {
  components: {
    BSpinner,
    BButton,
    TalentosCard: () => import('./TalentosCard.vue'),
  },
  data() {
    return {
      proposals: [],
      loading: true,
      countries: getCountries(),
    }
  },
  created() {
    proposal_service.getProposals().then((response) => {
      if (response.results) {
        const vanity_name = getUserData().meta_info.vanity_name
        this.proposals = response.results.filter(item => item.user && item.user.vanity_name !== vanity_name)
      }
    }).finally(() => { this.loading = false })
  },
  methods: {
    onUnlinked(uuid) {
      this.proposals = this.proposals.filter(item => item.uuid !== uuid)
    },
  },
}
</script>

<style scoped>
.grid-talentos {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 1.25rem;
}
</style>
